import { useMemo } from 'react';

import { PlaceOrderContext } from 'pages/place_order/context';
import { Outlet, useLocation } from 'react-router-dom';
import { DefaultLayout } from 'components/layout';
import { getStringFromURL } from 'utils/other';
import { PartnerTypes } from 'apis/PartnerApi';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export type PlaceOrderPermissions = {
    CanPlaceOrder: boolean;
    ShowAutofill: boolean;
    ShowComment: boolean;
    ShowRenewTab: boolean;
};

export type PlaceOrderContextValue = {
    orderFor: string;
    permissions: PlaceOrderPermissions;
    requestingPartnerId: number;
};

export const PlaceOrder = () => {

    const { formatMessage } = useIntl();
    const location = useLocation();
    const orderFor = useMemo(() => getStringFromURL('OrderFor') ?? 'None', [location.search]);

    const { highestRole, selectedPartner } = useApp();

    const resolvedRoleId = highestRole.id ?? 0;

    // The orderable license list must reflect what the partner the order is being
    // placed for can order — i.e. the selected partner (a Testing Center when
    // ordering by proxy), not the acting user's own partner. Scoping the lookup to
    // the selected partner keeps proxy orders limited to the TC's orderable set.
    const requestingPartnerId = selectedPartner.id;

    const resolvedPermissions: PlaceOrderPermissions = {
        CanPlaceOrder: true,
        ShowAutofill: orderFor.toLowerCase() === 'proxy',
        ShowComment: resolvedRoleId === 1,
        ShowRenewTab: selectedPartner.type === PartnerTypes.TestingCenter
    };

    const context: PlaceOrderContextValue = {
        orderFor,
        permissions: resolvedPermissions,
        requestingPartnerId
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'place_order.0da32b8f', defaultMessage: 'Place Order' })} >
            <PlaceOrderContext.Provider value={context}>
                <Outlet />
            </PlaceOrderContext.Provider>
        </DefaultLayout >
    );

};
